import { useQuery } from '@tanstack/react-query'
import { httpClient } from './httpClient'

export const KEYS = {
  SCHOOLS: 'schools',
}

const getSchools = async (country = '', schoolName = '') => {
  const response = await httpClient.get('/school/autocomplete', {
    params: {
      q: schoolName?.toLocaleLowerCase(),
      country,
    },
  })
  return response.data
}

export const useSchools = (country = '', schoolName = '') =>
  useQuery(
    [KEYS.SCHOOLS, `country=${country}`, `school=${schoolName}`],
    async () => getSchools(country, schoolName),
    {
      enabled: Boolean(schoolName?.length >= 3 && country),
    }
  )
